import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate, TextFormat, getPaginationState, JhiPagination, JhiItemCount } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities } from './produit.reducer';

export const Produit = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const produitList = useAppSelector(state => state.produit.entities);
  const loading = useAppSelector(state => state.produit.loading);
  const totalItems = useAppSelector(state => state.produit.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      }),
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    } else {
      return order === ASC ? faSortUp : faSortDown;
    }
  };

  return (
    <div>
      <h2 id="produit-heading" data-cy="ProduitHeading">
        <Translate contentKey="alexisExportApp.produit.home.title">Produits</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="alexisExportApp.produit.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/produit/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="alexisExportApp.produit.home.createLabel">Create new Produit</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {produitList && produitList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="alexisExportApp.produit.id">ID</Translate> <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('name')}>
                  <Translate contentKey="alexisExportApp.produit.name">Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('name')} />
                </th>
                <th className="hand" onClick={sort('provenance')}>
                  <Translate contentKey="alexisExportApp.produit.provenance">Provenance</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('provenance')} />
                </th>
                <th className="hand" onClick={sort('poids')}>
                  <Translate contentKey="alexisExportApp.produit.poids">Poids</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('poids')} />
                </th>
                <th className="hand" onClick={sort('priceDeVente')}>
                  <Translate contentKey="alexisExportApp.produit.priceDeVente">Price De Vente</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('priceDeVente')} />
                </th>
                <th className="hand" onClick={sort('prixInitial')}>
                  <Translate contentKey="alexisExportApp.produit.prixInitial">Prix Initial</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('prixInitial')} />
                </th>
                <th className="hand" onClick={sort('sachetDeProtection')}>
                  <Translate contentKey="alexisExportApp.produit.sachetDeProtection">Sachet De Protection</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('sachetDeProtection')} />
                </th>
                <th className="hand" onClick={sort('dateDExpedition')}>
                  <Translate contentKey="alexisExportApp.produit.dateDExpedition">Date D Expedition</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dateDExpedition')} />
                </th>
                <th className="hand" onClick={sort('dateDeReception')}>
                  <Translate contentKey="alexisExportApp.produit.dateDeReception">Date De Reception</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dateDeReception')} />
                </th>
                <th className="hand" onClick={sort('lienVersFichierPhoto')}>
                  <Translate contentKey="alexisExportApp.produit.lienVersFichierPhoto">Lien Vers Fichier Photo</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lienVersFichierPhoto')} />
                </th>
                <th className="hand" onClick={sort('datePersistence')}>
                  <Translate contentKey="alexisExportApp.produit.datePersistence">Date Persistence</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('datePersistence')} />
                </th>
                <th className="hand" onClick={sort('dateUpdate')}>
                  <Translate contentKey="alexisExportApp.produit.dateUpdate">Date Update</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dateUpdate')} />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {produitList.map((produit, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/produit/${produit.id}`} color="link" size="sm">
                      {produit.id}
                    </Button>
                  </td>
                  <td>{produit.name}</td>
                  <td>{produit.provenance}</td>
                  <td>{produit.poids}</td>
                  <td>{produit.priceDeVente}</td>
                  <td>{produit.prixInitial}</td>
                  <td>{produit.sachetDeProtection}</td>
                  <td>
                    {produit.dateDExpedition ? <TextFormat type="date" value={produit.dateDExpedition} format={APP_DATE_FORMAT} /> : null}
                  </td>
                  <td>
                    {produit.dateDeReception ? <TextFormat type="date" value={produit.dateDeReception} format={APP_DATE_FORMAT} /> : null}
                  </td>
                  <td>{produit.lienVersFichierPhoto}</td>
                  <td>
                    {produit.datePersistence ? <TextFormat type="date" value={produit.datePersistence} format={APP_DATE_FORMAT} /> : null}
                  </td>
                  <td>{produit.dateUpdate ? <TextFormat type="date" value={produit.dateUpdate} format={APP_DATE_FORMAT} /> : null}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/produit/${produit.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/produit/${produit.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/produit/${produit.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="alexisExportApp.produit.home.notFound">No Produits found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={produitList && produitList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default Produit;
